'use strict';

var LeadDetails = (function(win) {
    var
        query = win.location.search;
    var frameId = 'l2l_messenger';

    var LeadDetailsContainer = null;
    var LeadScoreContainer = null;

    var leadId = 0;

    var transaction = function(callback) {
        lead2lease.network.request('api', 'get', 'v1/Leads', {
            id: leadId
        }, null, function(error, data) {
            if(error != null) {
                console.log(error);
            }
            else {
                callback(JSON.parse(data.responseText));
            }
        });
    };

    var getLeadDetails = function() {
        transaction(function(res) {
            BuildHtml(res);
        });
    };

    var BuildHtml = function(data) {
        var fullName = document.createElement('strong');
        fullName.className = 'lead-full-name';
        fullName.innerHTML = data.Person.FirstName + ' ' + data.Person.LastName;

        var email = document.createElement('div');
        email.className = 'lead-email';
        email.innerHTML = data.Person.Email;

        var phone = document.createElement('div');
        phone.className = 'lead-phone';
        phone.innerHTML = (data.Person.CellPhone && data.Person.CellPhone !== '') ? data.Person.CellPhone : data.Person.HomePhone;

        var stage = lead2lease.ui.components.lead.stage(data.Stage);

        var score = lead2lease.ui.components.lead.score(data.Score);
        LeadDetailsContainer.appendChild(fullName);
        LeadDetailsContainer.appendChild(email);
        if(data.Person.HomePhone || data.Person.CellPhone) {
            LeadDetailsContainer.appendChild(phone);
        }
        LeadScoreContainer.appendChild(stage[0]);
        LeadScoreContainer.appendChild(score[0]);
    };

    var launch = function(id, leadDetailsContainer, leadScoreContainer) {
        LeadDetailsContainer = leadDetailsContainer;
        LeadScoreContainer = leadScoreContainer;
        leadId = id;

        getLeadDetails();
    };

    return {
        launch: launch
    };
})(window);
